import script from "./BalanceBarAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./BalanceBarAlert.vue?vue&type=script&setup=true&lang=js"

import "./BalanceBarAlert.vue?vue&type=style&index=0&id=3731d264&lang=scss"

const __exports__ = script;

export default __exports__